/**
HTMX
*/
import "htmx.org";
/**
Web Awesome components.
*/
import "@web.awesome.me/webawesome-pro/dist/components/button/button.js";
import "@web.awesome.me/webawesome-pro/dist/components/button-group/button-group.js";
import "@web.awesome.me/webawesome-pro/dist/components/color-picker/color-picker.js";
import "@web.awesome.me/webawesome-pro/dist/components/combobox/combobox.js";
import "@web.awesome.me/webawesome-pro/dist/components/data-grid/data-grid.js";
import "@web.awesome.me/webawesome-pro/dist/components/date-input/date-input.js";
import "@web.awesome.me/webawesome-pro/dist/components/dialog/dialog.js";
import "@web.awesome.me/webawesome-pro/dist/components/divider/divider.js";
import "@web.awesome.me/webawesome-pro/dist/components/icon/icon.js";
import "@web.awesome.me/webawesome-pro/dist/components/input/input.js";
import "@web.awesome.me/webawesome-pro/dist/components/option/option.js";
import "@web.awesome.me/webawesome-pro/dist/components/page/page.js";
import "@web.awesome.me/webawesome-pro/dist/components/textarea/textarea.js";
import "@web.awesome.me/webawesome-pro/dist/components/time-input/time-input.js";
/**
Work Monster scripts.
*/
import "./dark-theme.js";
/**
Work Monster components.
*/
import "./components/actions/delete.js";
import "./components/checklist/checklist.js";
import "./components/checklist/item.js";
import "./components/clear-button.js";
import "./components/date-output.js";
import "./components/datetime-input.js";
import "./components/metrics/create.js";
import "./components/metrics/definition.js";
import "./components/metrics/edit.js";
import "./components/metrics/grid.js";
import "./components/notes/content.js";
import "./components/notes/create.js";
import "./components/notes/details.js";
import "./components/notes/edit.js";
import "./components/notes/grid.js";
import "./components/notes/title.js";
import "./components/output.js";
import "./components/sign-in.js";
import "./components/tags-combobox.js";
import "./components/tags/create.js";
import "./components/tags/edit.js";
import "./components/tags/cell.js";
import "./components/tags/grid.js";
import "./components/tasks/available-tasks-grid.js";
import "./components/tasks/create.js";
import "./components/tasks/details.js";
import "./components/tasks/edit.js";
import "./components/tasks/done-today.js";

function selectOnceAndOnSwap<T extends Element>(
  selector: string,
  func: (nodes: NodeListOf<T>) => unknown,
) {
  document.addEventListener("htmx:after:swap", (event) => {
    if (event.target != null) {
      const nodes = (event.target as HTMLElement).querySelectorAll(selector);
      func(nodes as NodeListOf<T>);
    }
  });
  const nodes = document.querySelectorAll(selector);
  func(nodes as NodeListOf<T>);
}

selectOnceAndOnSwap<HTMLFormElement>("[data-form-error]", (nodes) => {
  const forms: Set<HTMLFormElement> = new Set();
  for (const node of nodes) {
    node.setCustomValidity(node.dataset.formError);
    // Reset to valid on new input.
    node.addEventListener("input", (_) => {
      node.setCustomValidity("");
    });
    // Keep track the parent forms to trigger report.
    forms.add(node.form);
  }

  for (const form of forms) {
    form.reportValidity();
  }
});

// TODO: semantically, this can be achieved with "output" types.
selectOnceAndOnSwap<HTMLFormElement>("[data-form-omit]", (nodes) => {
  for (const node of nodes) {
    if (node.dataset.formOmit != null) {
      // Adds an event listener on the parent form that removes
      // itself from the form data upon submittal.
      const form = node.form;
      form.addEventListener("formdata", (e: FormDataEvent) => {
        const formData = e.formData;
        formData.delete(node.name);
      });
    }
  }
});
